<template>
<div class="f-box">
    <div class="box-mobile" v-if="isMobiles">
        <div>东风南方保险代理有限公司 版权所有</div>
        <div>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备17109236号</a>
        </div>
        <div>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011402000796" target="_blank" rel="noopener noreferrer">粤公网安备440114020000796号</a>
            <el-image class="box-img" :src="home_6" />
        </div>
    </div>
    <div class="box-pc" v-else>
        东风南方保险代理有限公司 版权所有&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备17109236号</a>&nbsp;&nbsp;&nbsp;
        <el-image class="box-img" :src="home_6" />&nbsp;
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011402000796" target="_blank" rel="noopener noreferrer">粤公网安备440114020000796号</a>
    </div>
</div>
</template>

<script>
import {
    isMobile
} from '../../../libs/util'
export default {
    data() {
        return {
            home_5: require("../../../assets/home_5.jpg"),
            home_6: require("../../../assets/police.png"),
            isMobiles: false
        };
    },
    created() {
        this.isMobiles = isMobile()
    },
    methods: {
        changebtn(v) {
            switch (v) {
                case "1":
                    this.$router.push({
                        path: "/information"
                    }).catch(err => err);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.f-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #D9D9D9;
    font-size: 0.47rem;
    width: 100%;

    a {
        text-decoration: none;
        color: #D9D9D9;
    }

    a:hover {
        color: #FF9600;
    }

    .box-img {
        width: .57rem;
        height: .57rem;
    }

    .box-pc {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 1.6rem;
        background-color: #636363;
    }

    .box-mobile {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: -2.2rem;
        width: 100%;
        height: 5rem;
        color: #9298a5;
        background-color: #ECECEC;

        a {
            color: #9298a5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/layout/components/footer.vue